import Badge from "../../../badge"
import Tooltip from "../../../tool-tip"

const AfterHoursBadge = () => (
  <Tooltip
    toolTipNode={<Badge.Danger>After Hours</Badge.Danger>}
    text={<span className="text-[10px]">Sending @ 11 am EST</span>}
    placement="top"
  />
)

export default AfterHoursBadge
